<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <h3 class="title has-text-grey">{{ $t('modules.errors.page404.title') }}</h3>
                    <p class="subtitle has-text-grey">{{ $t('modules.errors.page404.notice') }}</p>



                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'page404'
    }
</script>
